import { ToastHost, TruncationTooltipHost } from "@carbon6/c6-frontend-design";
import type { RouteObject } from "react-router";
import { AppRouter } from "./AppRouter";
import { AppWindowHost } from "./AppWindowHost";

/**
 * 라우터 안의 앱 셸. 라우트는 `AppRouter` 의 `<Routes>` 가 고른다. 전역 오버레이도 라우터 컨텍스트(`useNavigate`)를
 * 쓸 수 있게 같은 자리에 둔다.
 */
function AppShell() {
  return (
    <>
      <AppRouter />
      {/* 전체화면 창 스택은 라우트 밖 · 라우터 안이다 — 최소화한 창이 화면 전환에도 남고 콘텐츠가
          라우터 훅을 쓴다. */}
      <AppWindowHost />
      {/* 토스트와 잘린 텍스트 툴팁은 라우트 밖의 전역 호스트다 — 화면이 바뀌어도 살아 있어야
          액션 결과 알림이 이동 도중에 사라지지 않는다. */}
      <ToastHost gravity="bottom-center" variant="icon-stripe" />
      <TruncationTooltipHost placement="top" />
    </>
  );
}

/**
 * data router 의 경로 표. 셸 하나를 모든 경로("*")에 세운다 — 어느 경로로 옮겨도 같은 route 라 셸(창 호스트 ·
 * 토스트)은 다시 마운트되지 않는다. 화면 경로는 `AppRouter` 가 그대로 갖는다.
 *
 * data router 를 쓰는 이유는 이동을 막는 `useBlocker` 다 — 저장하지 않은 편집이 있는 상세 페이지를 떠나기 전에 묻는다.
 */
export const appRoutes: RouteObject[] = [{ path: "*", element: <AppShell /> }];
